import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const PlusIcon = (props?: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <g clipPath="url(#clip0_6286_37452)">
      <path
        d="M9.99935 6.66699V13.3337M6.66602 10.0003H13.3327M18.3327 10.0003C18.3327 14.6027 14.6017 18.3337 9.99935 18.3337C5.39698 18.3337 1.66602 14.6027 1.66602 10.0003C1.66602 5.39795 5.39698 1.66699 9.99935 1.66699C14.6017 1.66699 18.3327 5.39795 18.3327 10.0003Z"
        stroke="#19191B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_6286_37452">
        <rect height="20" width="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
